export class Banner {
  url = "";
  label = "";
  imageUrl = "";
}
